import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { MotionPlugin } from '@vueuse/motion'
import VueGtag from "vue-gtag";

loadFonts()

createApp(App)
  .use(router)  
  .use(VueGtag, {
    config: { id: "G-THEL7FPK7S" }
  })
  .use(store)
  .use(MotionPlugin)
  .use(vuetify)
  .mount('#app')
